import React, { useEffect } from 'react';
import wrenchImage from '../../../assets/img/wrench.svg';
import GetSVG, { SVGID } from '../../Common/GetSVG';

interface IProps {
  onClose: () => void;
}

const ReportImageModal = (props: React.PropsWithChildren<IProps>) => {
  const {
    onClose,
  } = props;

  useEffect(() => {
    document.body.classList.add('overflow-modal');
    setTimeout(() => {
      document.getElementById('report-modal')!.classList.add('active');
    }, 100);
  }, []);

  const onClosePopup = () => {
    document.body.classList.remove('overflow-modal');
    document.getElementById('report-modal')!.classList.remove('active');
    setTimeout(() => {
      onClose();
    }, 200);
  };

  return (
    <div id="report-modal" className="modal">
      <div className="modal-card">
        <div className="modal-card-body !rounded-xl !shadow-md max-w-sm">
          <div className="modal-card-head text-right relative">
            <button
              type="button"
              className="absolute md:relative -right-3 -top-3 md:-right-6 md:-top-4 h-8 w-8 text-black ml-auto group hover:bg-themered hover:bg-opacity-5 group flex items-center justify-center text-sm font-light rounded-md cursor-pointer --jbi-modal-close"
              onClick={onClosePopup}
            >
              <GetSVG ID={SVGID.CLOSE_ICON} svgClass="i-svg fill-themered h-4 w-4 group-hover:fill-themered group-focus:fill-themered" />
            </button>
          </div>
          <div className="text-center pb-6">
            <div className="pb-6">
              <img src={wrenchImage} className="mx-auto" alt="Report" />
            </div>
            <h2 className="h2 mb-1">Report Image</h2>
            <p className="text-base">Thank you. Your report has been received and the image will be removed from your gallery.</p>
          </div>
        </div>
      </div>
      <div className="modal-background" />
    </div>
  );
};

export default ReportImageModal;
